export const DAYJS_FORMAT = {
  DATE_FORMAT: 'MM/YYYY',
  FULL_DATE_FORMAT: 'DD-MM-YYYY',
  TIME_ONLY: 'HH:mm',
  FULL_DATE_FORMAT_2: 'DD/MM/YYYY',
  FULL_DATE_FORMAT_3: 'D/M/YYYY',
  MONTH_FORMAT: 'MM/YYYY',
  MONTH_ONLY_FORMAT: 'MMMM',
  YEAR_FORMAT: 'YYYY',
  FOOD_CREATED_ON: 'MM/DD/YYYY',
  FULL_DATE_FORMAT_WITH_SLASH: 'MM/DD/YYYY',
  ISO_STRING: 'YYYY-MM-DDTHH:mm:ss',
  DATE_AND_TIME: 'YYYY-MM-DD HH:mm:ss',
  DATE_MONTH_CHAR: 'DD MMM YYYY',
  MONTH_DAY_YEAR: 'MMM DD, YYYY',
  ISO_YEAR_MONTH_DATE: 'YYYY-MM-DD',
  ISO_TIME: 'HH:mm:ss',
  FULL_DATETIME: 'MMM DD YYYY, h:mm A',
};

export const GENDER = {
  MALE: 'common.male',
  FEMALE: 'common.female',
  // OTHER: 'common.other',
};

export enum QUEUED_SAMPLE_ACTION {
  ADD_TO_QUEUE = 'ADD_TO_QUEUE',
  DELETE_FROM_QUEUE = 'DELETE_FROM_QUEUE',
  CLEAR_QUEUE = 'CLEAR_QUEUE',
}

export enum SAMPLE_FILES {
  AMD_PARTICIPANTS = 'sample-files/amd/Lab ID Sample File.csv',
  BME_PARTICIPANTS = 'sample-files/bme/Lab ID Sample File.csv',
  USERS = 'sample-files/users.csv',
  SYSTEM = 'sample-files/SystemSampleFile.csv',
  KIT_ATTRIBUTES = 'kit-files/Attributes-Sample-File.csv',
  ANALYSIS_SAMPLES_SURVEY = 'kit-files/Analysis-Survey-Sample-File.csv',
}

export enum SCANNED_KITS_ACTION {
  ADD_TO_QUEUE = 'queuedScannedKits/ADD_TO_QUEUE',
  CLEAR_QUEUE = 'queuedScannedKits/CLEAR_QUEUE',
}

export enum LANGUAGE {
  EN = 'en',
  CN = 'cn',
  AR = 'ar',
}

export enum MethodEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum ConditionEnum {
  AND = 'AND',
  OR = 'OR',
}

export enum STATUS {
  ACTIVATED = 'activated',
  DISABLED = 'disabled',
}

export enum ChartKey {
  SAMPLES = 'SAMPLES',
  REPORTS = 'REPORTS',
}

export enum RoleLevelEnum {
  SUPER_ADMIN = 1,
  ADMIN = 2,
}
export const DEFAULT_ORG = 'amili';

export enum SORT_ORDER {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum Currency {
  THB = 'THB',
  MYR = 'MYR',
  PHP = 'PHP',
  IDR = 'IDR',
  VND = 'VND',
  SAR = 'SAR',
  HKD = 'HKD',
  SGD = 'SGD',
}
